import { render } from "./Root.vue?vue&type=template&id=541d3cfa&scoped=true&ts=true"
import script from "./Root.vue?vue&type=script&lang=ts"
export * from "./Root.vue?vue&type=script&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=541d3cfa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541d3cfa"]])

export default __exports__